// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  or: 'Ou',
  text: 'crie uma conta',
  title: 'clique aqui para criar uma conta',
} as ILanguage;
